var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { animated } from '@react-spring/web';
var cls = classNames('svg-image');
export var SvgImageDefaultProps = {
  preserveAspectRatio: 'xMidYMid slice',
  onLoad: function () {},
  encode: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Image: styled(animated.image)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SvgImage = function (props) {
  var className = props.className,
    href = props.href,
    width = props.width,
    height = props.height,
    encode = props.encode,
    onLoad = props.onLoad,
    rest = __rest(props, ["className", "href", "width", "height", "encode", "onLoad"]);
  var _a = __read(useState(href), 2),
    resolvedHref = _a[0],
    setResolvedHref = _a[1];
  useEffect(function () {
    if (encode) {
      // Function to fetch and convert image to base64
      var convertImageToBase64 = function (url) {
        return __awaiter(void 0, void 0, void 0, function () {
          var response, blob, reader_1, error_1;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                _a.trys.push([0, 3,, 4]);
                return [4 /*yield*/, fetch(url)];
              case 1:
                response = _a.sent();
                return [4 /*yield*/, response.blob()];
              case 2:
                blob = _a.sent();
                reader_1 = new FileReader();
                reader_1.onloadend = function () {
                  setResolvedHref(reader_1.result);
                  onLoad(reader_1.result);
                };
                reader_1.onerror = function (error) {
                  return console.error('Error converting image to base64', error);
                };
                reader_1.readAsDataURL(blob);
                return [3 /*break*/, 4];
              case 3:
                error_1 = _a.sent();
                console.error('Error fetching the image', error_1);
                return [3 /*break*/, 4];
              case 4:
                return [2 /*return*/];
            }
          });
        });
      };
      // Convert the image once the component is mounted
      convertImageToBase64(href);
    } else {
      setResolvedHref(href);
      onLoad(resolvedHref);
    }
  }, [href, encode]);
  return /* @ts-ignore */(
    React.createElement(My.Image, __assign({
      className: cls.name(className),
      href: resolvedHref,
      width: width,
      height: height,
      preserveAspectRatio: "xMidYMid slice"
    }, rest))
  );
};
SvgImage.cls = cls;
SvgImage.defaultProps = SvgImageDefaultProps;
var templateObject_1, templateObject_2;